import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AppInfo } from '@app/core/models/app-info';
import { requiredValidator } from '@app/shared/validators';
import { isFalse } from '@util';

const FIELD_REQUIRED_MSG = 'This field is required';

@Component({
  selector: 'pcs-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginFormComponent implements OnInit {
  @Input() appInfo: AppInfo;
  @Input() authError: boolean;
  @Output() submitted = new EventEmitter();
  @Output() changed = new EventEmitter();

  form: UntypedFormGroup;

  constructor(private fb: UntypedFormBuilder) {
  }

  get ipDocumentation() {
    return this.appInfo.ipDocumentation;
  }

  get documentation() {
    return this.appInfo.documentation;
  }

  get mailPcsSupport() {
    return this.appInfo.mailPcsSupport;
  }

  get requestNewAccountUrl() {
    return this.appInfo.requestNewAccountUrl;
  }

  get requestPasswordChangeUrl() {
    return this.appInfo.requestPasswordChangeUrl;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: [, requiredValidator(FIELD_REQUIRED_MSG)],
      password: [, requiredValidator(FIELD_REQUIRED_MSG)]
    });
  }

  onSubmit() {
    if (this.isValid()) {
      this.submitted.emit(this.form.value);
    }
  }

  isValid() {
    return this.form.valid && isFalse(this.authError);
  }

}
